/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

interface ActionButtonProps {
    type?: string;
    children?: React.ReactNode;
    highlighted?: boolean;
}

const ActionButton: FunctionComponent<ActionButtonProps> = ({ type, children, highlighted }) => {
    const displayText = type === 'options' ? 'Options' : 'See more info';

    return (
        <div
            className={`uikit btn primary-text-style text-size-large ${highlighted ? 'highlighted' : ''}`}
        >
            {children || displayText}
        </div>
    );
};

export default ActionButton;
